<template>
    
    <span v-if="hasEventWebhook(event) && (user.is_internal || user.is_admin || user.is_master)">
        <emc-button-icon iconSmall :color="color" :loading="loading" :text="text" :icon="icon" @click.prevent.stop="processWebhook()" />
    </span>
    
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: "EmcButtonWebhookProcess",
    data: () => ({
        dialog: false,
        loading: false,
        error: false,
        message: '',
        errors: [],
    }),
    created(){
        
    },
    
    props: {
        
        color: {
            type: String,
            default: 'green lighten-1'
        },
        icon: {
            type: String,
            default: "mdi-webhook"
        },
        title: {
            type: String,
            default: 'Importação'
        },
        event: {
            type: String,
            required: true
        },
        itemId: {
            type: Number,
            required: true
        },
        column: {
            type: String
        },
        text: {
            type: String,
            default: 'Processar webhook'
        }
    },
    computed: {
        ...mapState('auth', ['user'])
    },
    methods:{
        
        ...mapActions('webhook', ['ActionWebhookProcess']),
        
        processWebhook(){

            this.errors = [];
            this.error = false;
            this.message = '';
            this.loading = true;
            let payload = {
                event: this.event,
                item_id: this.itemId,
                column: this.column
            }

            this.ActionWebhookProcess(payload)
                .then((res) => {
                    
                    res.message = res.message;

                }).catch(error => {

                    this.error = true;
                    this.message = error.message;

                }).finally(() => {
                    this.loading = false;
                });

        },
        
    }
}
</script>
